export default __webpack_public_path__ + "locales/it/Article.json?hash=a3bb5b24e56d6c145a80b6c1472e1b28";